// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal {
  padding: 60px 20px;
  font-size: 18px;
  background-color: #F5F5F5;
  color: #434C63;
  border-radius: 12px;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 800;
  transform: translate(-50%, -50%);
  transition: opacity 0.3s;
  opacity: 0;
}

.error-modal.visible {
  opacity: 1;
}

.error-modal.hidden {
  opacity: 0;
  z-index: -20;
}`, "",{"version":3,"sources":["webpack://./src/components/Error/ErrorModal/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gCAAgC;EAChC,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;AACd","sourcesContent":[".error-modal {\n  padding: 60px 20px;\n  font-size: 18px;\n  background-color: #F5F5F5;\n  color: #434C63;\n  border-radius: 12px;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  z-index: 800;\n  transform: translate(-50%, -50%);\n  transition: opacity 0.3s;\n  opacity: 0;\n}\n\n.error-modal.visible {\n  opacity: 1;\n}\n\n.error-modal.hidden {\n  opacity: 0;\n  z-index: -20;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
